import { Box, Button, CircularProgress } from "@mui/material";
import FilterManager from "./FilterManager";
import { Download, Print } from "@mui/icons-material";
import localize from "../../common/localize";

export default function FilterWithPrinter({
  filterItemNameValue,
  filterDataValue,
  setFilterDataValue,
  defaultFilteringValue,
  filterOptionsValue,
  lateral_padding,
  printButtonMethod,
  isPrintLoading,
  printButtonDisabled,
}) {
  return (
    <Box className="flex justify-between gap-2 w-full flex-wrap">
      <FilterManager
        filterItemNameValue={filterItemNameValue}
        filterDataValue={filterDataValue}
        setFilterDataValue={setFilterDataValue}
        defaultFilteringValue={defaultFilteringValue}
        filterOptionsValue={filterOptionsValue}
        lateral_padding={lateral_padding}
      />

      {printButtonMethod && (
        <Box>
          <Button
            disabled={printButtonDisabled}
            size="small"
            variant="contained"
            sx={{
              backgroundColor: "var(--app-bg, #10366E)",
              color: "var(--app-fg, #ffffff)",
              "&:hover": { backgroundColor: "var(--app-bg, #10366E)" },
            }}
            className="app_general_button_data btn-sm"
            onClick={printButtonMethod}
          >
            <span className="mr-2">{localize.export}</span>
            {!isPrintLoading ? (
              <Download />
            ) : (
              <CircularProgress style={{ width: "20px", height: "20px" }} />
            )}
          </Button>
        </Box>
      )}
    </Box>
  );
}
